// extracted by mini-css-extract-plugin
export default {"mCard":"pA-z","image":"qA-z","imageNoBackground":"rA-z","imageHasCategory":"sA-z","fullWidth":"tA-z"};